document.addEventListener('turbolinks:load', function () {
  // ¥ 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // ¥ manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }

  const ERROR_MSG = 'エラー！ 処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;

  const DOMAIN = $('#pl_domain').val();

  let current_url = location.href;

  // ###################################################
  // ¥ UGC最適化設定
  // ###################################################

  // ¥ 初期化 UGC表示最適化設定の更新ボタンを押せるようにする
  const initialize_ugc_optimization_button = function (param) {
    // 初期化 UGC表示最適化設定の更新ボタンを押せるようにする
    $(`.ugc_optimization_submit`).removeClass('pointer-events-none bg-gray-500');
  };

  let selected_group_el = $('#ugc_optimization_group_select option:selected');
  const ugc_group_list = ['s', 'a', 'b', 'c'];
  let group_ugc_display_num_list = [];
  let group_ugc_item_actual_total_count = Number(selected_group_el.data('ugc_item_total_count'));

  // ¥ UGCグループの選択で、初期のグループ名でない選択肢の場合は PC / PHONEの切替を表示させない
  if (location.href.includes('/ugc_optimization') && $('#ugc_optimization_group_select option:selected').data('ugc_item_total_count') === -99) {
    $('.ugc_optimization_device_wrapper').css('display', 'none');
  }

  // ¥ グループが選択されるまで全ての要素を隠す
  const ugc_opt_hide_options = function () {
    $('.ugc_optimization__container--with_rank').css('display', 'none');
    $('.ugc_optimization__container--no_rank').css('display', 'none');
    // ¥ url入力フォームとsubmitボタンを隠す
    $('.ugc_optimization__url_container').css('display', 'none');
    $('.ugc_optimization_submit').css('display', 'none');
  };

  // ¥ UGC最適化設定ページのみで発動するコード
  if (current_url.includes('/ugc_optimization')) {
    group_ugc_item_actual_total_count = Number(selected_group_el.data('ugc_item_total_count'));

    // ¥ グループが選択されるまで全ての要素を隠す
    if (group_ugc_item_actual_total_count === -99) {
      ugc_opt_hide_options();
    }

    // ¥ UGCグループを変更時
    // ¥ UGCグループの選択で、存在するグループ名の選択肢の場合は PC / PHONEの切替を表示させる
    $('#ugc_optimization_group_select').on('change', function () {
      if ($('#ugc_optimization_group_select option:selected').data('ugc_item_total_count') !== -99) {
        $('.ugc_optimization_device_wrapper').css('display', 'block');
      } else {
        $('.ugc_optimization_device_wrapper').css('display', 'none');
      }

      // 初期化 UGC表示最適化設定の更新ボタンを押せるようにする
      initialize_ugc_optimization_button();

      selected_group_el = $('#ugc_optimization_group_select option:selected');
      group_ugc_item_actual_total_count = Number(selected_group_el.data('ugc_item_total_count'));

      //  ¥ 選択されている device_typeを動的に取得する
      let selected_device_type_el = $('.ugc_optimization__device_type.opacity-50');

      // - ugcグループの切り替えのタイミングでは毎回 pc に戻す
      let device_type = 0;

      location.href = `/ugc_optimization?device_type=${device_type}&ugc_group=${selected_group_el.data('group_id')}`;
    });

    // ¥ グループごとに属しているugc一覧を表示
    // Single function to handle the toggling of visibility
    function toggleVisibility(data_target) {
      let rank_container = $(data_target.data('target')); // Use data attribute to get target

      if (rank_container.hasClass('hidden')) {
        rank_container.hide().removeClass('hidden').css('display', 'flex').hide().fadeIn();
      } else {
        rank_container.fadeOut(function () {
          $(this).addClass('hidden');
        });
      }
    }

    // Event binding data-targetの値に表示、非表示させたい要素を入れる
    $('div[data-target]')
      .off('click')
      .on('click', function () {
        toggleVisibility($(this));
      });

    //¥ UGC表示最適化設定 - PC / PHONE デバイス切替時の動作 共通関数
    const device_change_get_display_count = function (selected_device) {
      let ugc_group = $('#ugc_optimization_group_select option:selected').data('group_id');
      selected_group_el = $('#ugc_optimization_group_select option:selected');
      group_ugc_item_actual_total_count = Number(selected_group_el.data('ugc_item_total_count'));
      let device_type = $(`.ugc_optimization_device_${selected_device}`).data('device');

      $.ajax({
        type: 'GET',
        url: DOMAIN + '/get_ugc_display_number',
        data: {
          selected_group_id: selected_group_el.data('group_id'),
          selected_group_name: selected_group_el.data('group_name'),
          selected_device_type: device_type,
        },
        dataType: 'json',
        success: function (response) {
          // ¥ 最新の各ランクが所有しているUGCの数を表示
          ranks = ['s', 'a', 'b', 'c'];

          // 最適化表示かつgrid表示選択時に表示させるugc数をランクごとに表示させる
          $.each(response.display_num_list, function (idx, val) {
            $(`#${ranks[idx]}_ugc_num_${idx}`).val(val);
            $(`.ugc_optimization__input--display_${idx}`).attr('display::', val);
          });

          // 保有している総保有UGC数をランクごとに表示させる
          $.each(response.max_num_list, function (idx, val) {
            $(`.ugc_optimization__input--display_${idx}`).attr('max::', val);
          });
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // error code here
        },
      });
    };

    //¥ UGC表示最適化設定 - PC / PHONE デバイス切替時の動作 選択されたデバイスボタンを青くする
    function toggleDeviceButtons(activeElement, inactiveElement, device, val) {
      device_change_get_display_count(device);

      activeElement.removeClass('opacity-100');
      activeElement.addClass('pointer-events-none');
      activeElement.addClass('opacity-50');

      inactiveElement.removeClass('opacity-50');
      inactiveElement.removeClass('pointer-events-none');
      inactiveElement.addClass('opacity-100');

      $('#ugc_optimization_device_val').val(val);
      initialize_ugc_optimization_button();
    }

    $('.ugc_optimization_device_pc')
      .off('click')
      .on('click', function () {
        toggleDeviceButtons($(this), $('.ugc_optimization_device_phone'), 'pc', 0);
      });

    $('.ugc_optimization_device_phone')
      .off('click')
      .on('click', function () {
        toggleDeviceButtons($(this), $('.ugc_optimization_device_pc'), 'phone', 1);
      });

    // ¥ input要素が変更されたらugc表示する数が表示できる実際の数を超過しないか評価する
    $('.ugc_optimization__input--display').on('change', function () {
      selected_group_el = $('#ugc_optimization_group_select option:selected');
      group_ugc_item_actual_total_count = Number(selected_group_el.data('ugc_item_total_count'));

      // 初期化 UGC表示最適化設定の更新ボタンを押せるようにする
      $('.show_exceed_num_alert').remove();
      $(`.ugc_optimization_submit`).removeClass('bg-base-500 dark:bg-dark_base');

      // ¥ DBではなくユーザーが入力した現在のwebページに表示させるUGCの数を取得する
      let current_display_num_list = $.map($('.ugc_optimization__input--display'), function (display_num, m_idx) {
        if (!$(display_num).val()) {
          return 'no_value';
        } else {
          $(`.ugc_optimization_submit`).removeClass('pointer-events-none bg-gray-500');
          $(`.ugc_optimization_submit`).addClass('bg-base-500 dark:bg-dark_base');
          return Number($(display_num).val());
        }
      });

      let each_rank_max_ugc_count_list = [$('#s_ugc_num_0').attr('max'), $('#a_ugc_num_1').attr('max'), $('#b_ugc_num_2').attr('max'), $('#c_ugc_num_3').attr('max')];

      for (let idx = 0; idx < current_display_num_list.length; idx++) {
        const current_display_num = current_display_num_list[idx];
        if (typeof current_display_num !== 'number') {
          $(`.ugc_optimization__input--display_${idx}`).val('');
          $(`.ugc_optimization__input--display_${idx}`).before("<p class='show_exceed_num_alert text-danger-700 text-sm'>保有UGC数以下の数字を設定してください。</p>");
          $(`.ugc_optimization_submit`).addClass('pointer-events-none bg-gray-500 ');
          $(`.ugc_optimization_submit`).addClass('pointer-events-none bg-gray-500 ');
        } else if (current_display_num > Number(each_rank_max_ugc_count_list[idx])) {
          // alert("NG!!");
          $(`.ugc_optimization__input--display_${idx}`).val('');
          $(`.ugc_optimization__input--display_${idx}`).before("<p class='show_exceed_num_alert text-danger-700 text-sm'>保有UGC数以下の数字を設定してください。</p>");
          $(`.ugc_optimization_submit`).addClass('pointer-events-none bg-gray-500 ');
        } else {
          $(`.ugc_optimization__input--display_${idx}`).removeClass('pointer-events-none, bg-gray-500');
        }
      }
    });

    $('#display_prioritized_ugc_flag').change(function () {
      let prioritized_ugc_flag = 0;
      let ugc_group_id = $('#ugc_optimization_group_select option:selected').attr('data-group_id');
      let device_type = $('.ugc_optimization__device_type.opacity-50').data('device'); // 0:pc 1: phone

      $('.ugc_optimization__device_type').hasClass('opacity-50');

      if ($('#display_prioritized_ugc_flag').prop('checked')) {
        prioritized_ugc_flag = 1;
      } else {
        prioritized_ugc_flag = 0;
      }
      $.ajax({
        url: '/update_is_displayed_prioritized_ugc',
        type: 'POST',
        data: {
          ugc_group_id: ugc_group_id,
          prioritized_ugc_flag: prioritized_ugc_flag,
          device_type: device_type,
        },
        dataType: 'json',
      })
        .done(function (data) {
          // ¥ 改行を残してそれ以外の不要な空白を削除する
          alert(`設定を変更しました。`.replace(/[ \t]/g, ''));
        })
        .fail(function (jqXHR, textStatus, errorThrown) {})
        .always(function () {
          location.reload();
        });
    });

    // 関連商品の連携をしてから表示させる日数を変更する処理(DB更新)
    $('#ugc_optimization_prioritized_position').change(function () {
      let ugc_prioritized_position = $('#ugc_optimization_prioritized_position option:selected').val();
      let ugc_group_id = $('#ugc_optimization_group_select option:selected').attr('data-group_id');
      if (ajax_save_ugc_display_num((alarm_flag = false)) == false) {
        location.reload();
        return;
      }

      $.ajax({
        url: '/update_ugc_prioritized_position',
        type: 'POST',
        data: {
          ugc_group_id: ugc_group_id,
          ugc_prioritized_position: ugc_prioritized_position,
        },
        dataType: 'json',
      })
        .done(function (data) {
          // ¥ 改行を残してそれ以外の不要な空白を削除する
          alert('設定を変更しました。');
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          alert(
            `設定の変更に失敗しました。
          再度お試しください。問題が継続する場合、弊社カスタマーサクセスまでご連絡ください。
          `.replace(/[ \t]/g, '')
          );
        })
        .always(function () {
          location.reload();
        });
    });

    // 関連商品の連携をしてから表示させる日数を変更する(dbに保存する前)前の日数を取得
    let ugc_previous_prioritized_period = $('#ugc_optimization_prioritized_ugc_select option:selected').val() || '';

    // 関連商品の連携をしてから表示させる日数を変更する処理(DB更新)
    $('#ugc_optimization_prioritized_ugc_select').change(function () {
      let ugc_prioritized_period = $('#ugc_optimization_prioritized_ugc_select option:selected').val();
      let ugc_group_id = $('#ugc_optimization_group_select option:selected').attr('data-group_id');

      //  - SABCの順に選択されたグループのugc設定表示数を保存する
      let ugc_display_num_list = [];

      for (let idx = 0; idx < $('.ugc_optimization__input--display').length; idx++) {
        const element = $('.ugc_optimization__input--display')[idx];

        if (Number($(element).val()) > Number($(`.opt_ugc_count_${idx}`).text())) {
          alert('保有UGC数を超えた数を入力しています。修正をお願いします。');
          return false;
        }

        ugc_display_num_list.push($(element).val());
      }

      let selected_group_el = $('#ugc_optimization_group_select option:selected');

      // ¥ 各ランクごとの保有UGC数を取得する
      let ugc_display_max_num_list = [];
      $.each($('.ugc_optimization__input--display'), function (idx, el) {
        ugc_display_max_num_list.push($(el).attr('max'));
      });

      $.ajax({
        url: '/update_ugc_prioritized_period',
        type: 'POST',
        data: {
          ugc_group_id: ugc_group_id,
          ugc_prioritized_period: ugc_prioritized_period,
          ugc_previous_prioritized_period: ugc_previous_prioritized_period,
        },
        dataType: 'json',
      })
        .done(function (data) {
          alert('関連商品の連携をしてから表示させる日数を変更しました。');
          location.reload();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          alert(
            `関連商品の連携をしてから表示させる日数の変更に失敗しました。
          再度お試しください。問題が継続する場合、弊社カスタマーサクセスまでご連絡ください。
          `.replace(/[ \t]/g, '')
          );
        });
    });

    const ajax_save_ugc_display_num = function (alert_flag = true) {
      //  - SABCの順に選択されたグループのugc設定表示数を保存する
      let ugc_display_num_list = [];

      for (let idx = 0; idx < $('.ugc_optimization__input--display').length; idx++) {
        const element = $('.ugc_optimization__input--display')[idx];

        if (Number($(element).val()) > Number($(`.opt_ugc_count_${idx}`).text())) {
          alert('保有UGC数を超えた数を入力しています。修正をお願いします。');
          return false;
        }

        ugc_display_num_list.push($(element).val());
      }

      let selected_group_el = $('#ugc_optimization_group_select option:selected');

      // ¥ 各ランクごとの保有UGC数を取得する
      let ugc_display_max_num_list = [];
      $.each($('.ugc_optimization__input--display'), function (idx, el) {
        ugc_display_max_num_list.push($(el).attr('max'));
      });

      $.ajax({
        type: 'POST',
        url: DOMAIN + '/save_ugc_display_num',
        data: {
          selected_group_id: selected_group_el.data('group_id'),
          selected_group_name: selected_group_el.data('group_name'),
          ugc_display_num_list: ugc_display_num_list,
          ugc_display_max_num_list: ugc_display_max_num_list,
          selected_device_type: $('#ugc_optimization_device_val').val(),

          // ugc_fixed_display_num_list: ugc_fixed_display_num_list,
        },
        dataType: 'json',
        success: function (response) {
          alert_flag ? alert('設定を更新しました。') : '';
          location.reload();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // error code here
        },
      });
    };

    // * 最適化設定を更新ボタンをクリック - SABCの順に選択されたグループのugc設定表示数や固定表示数をDBに保存する
    $('#ugc_optimization__submit')
      .off('click')
      .on('click', function () {
        if (group_ugc_item_actual_total_count === -99) {
          alert('UGCグループを選択してください。');
        } else {
          ajax_save_ugc_display_num();
        }
      }); // $('#ugc_optimization__submit')
  }
}); // end of document.addEventListener("turbolinks:load", function () {
